(function(){
  if (matchMedia('(prefers-reduced-motion:reduce)').matches) return;
  // Find a host element on the home (cover section)
  var host = document.querySelector('.edition .ed-cover');
  if (!host) return;

  // Lazy-load Three.js once
  function loadThree(cb){
    if (window.THREE) return cb();
    var s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.min.js';
    s.onload = cb;
    document.head.appendChild(s);
  }

  loadThree(function(){
    var THREE = window.THREE;
    var canvas = document.createElement('canvas');
    canvas.id = 'ona3dCanvas';
    host.insertBefore(canvas, host.firstChild);

    var W = host.clientWidth, H = host.clientHeight;
    var renderer = new THREE.WebGLRenderer({canvas:canvas, alpha:true, antialias:true});
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.setSize(W, H, false);

    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(60, W/H, 0.1, 100);
    camera.position.z = 14;

    // Particles : floating dust in mauve/lilas tones
    var COUNT = 240;
    var positions = new Float32Array(COUNT * 3);
    var sizes = new Float32Array(COUNT);
    var colors = new Float32Array(COUNT * 3);
    var palette = [
      [0.82, 0.71, 0.71],   // mauve #D2B4B4
      [0.72, 0.64, 0.79],   // lilas #B8A4C9
      [0.94, 0.88, 0.82],   // beige #F0E0D0
      [0.48, 0.46, 0.66],   // periwinkle
    ];
    for (var i=0; i<COUNT; i++){
      positions[i*3]   = (Math.random() - 0.5) * 26;
      positions[i*3+1] = (Math.random() - 0.5) * 18;
      positions[i*3+2] = (Math.random() - 0.5) * 14;
      sizes[i] = 0.05 + Math.random() * 0.18;
      var c = palette[Math.floor(Math.random() * palette.length)];
      colors[i*3] = c[0]; colors[i*3+1] = c[1]; colors[i*3+2] = c[2];
    }
    var geo = new THREE.BufferGeometry();
    geo.setAttribute('position', new THREE.BufferAttribute(positions, 3));
    geo.setAttribute('size',     new THREE.BufferAttribute(sizes, 1));
    geo.setAttribute('color',    new THREE.BufferAttribute(colors, 3));

    var mat = new THREE.PointsMaterial({
      size: 0.18,
      vertexColors: true,
      transparent: true,
      opacity: 0.55,
      depthWrite: false,
      blending: THREE.NormalBlending,
      sizeAttenuation: true,
    });

    // Soft circular sprite via canvas texture
    var sc = document.createElement('canvas'); sc.width = sc.height = 64;
    var sg = sc.getContext('2d');
    var grad = sg.createRadialGradient(32,32,0, 32,32,32);
    grad.addColorStop(0, 'rgba(255,255,255,1)');
    grad.addColorStop(0.5, 'rgba(255,255,255,0.5)');
    grad.addColorStop(1, 'rgba(255,255,255,0)');
    sg.fillStyle = grad; sg.fillRect(0,0,64,64);
    mat.map = new THREE.CanvasTexture(sc);

    var points = new THREE.Points(geo, mat);
    scene.add(points);

    // Mouse interaction
    var mx = 0, my = 0, tx = 0, ty = 0;
    host.addEventListener('mousemove', function(e){
      var r = host.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width - 0.5) * 0.6;
      ty = ((e.clientY - r.top)  / r.height - 0.5) * 0.6;
    });

    var t0 = performance.now();
    function animate(){
      requestAnimationFrame(animate);
      var t = (performance.now() - t0) * 0.001;
      // Slow drift on Y axis + sway on X
      var pos = geo.attributes.position.array;
      for (var i=0; i<COUNT; i++){
        pos[i*3+1] += Math.sin(t * 0.4 + i) * 0.0015 + 0.003;  // gentle upward drift
        if (pos[i*3+1] > 9) pos[i*3+1] = -9;
        pos[i*3] += Math.cos(t * 0.3 + i) * 0.001;
      }
      geo.attributes.position.needsUpdate = true;
      // Camera responds to mouse
      mx += (tx - mx) * 0.04;
      my += (ty - my) * 0.04;
      camera.position.x = mx * 1.4;
      camera.position.y = -my * 1.0;
      camera.lookAt(0, 0, 0);
      // Subtle rotation
      points.rotation.y += 0.0008;
      renderer.render(scene, camera);
    }
    animate();

    function onResize(){
      W = host.clientWidth; H = host.clientHeight;
      camera.aspect = W/H; camera.updateProjectionMatrix();
      renderer.setSize(W, H, false);
    }
    window.addEventListener('resize', onResize);
  });
})();